<div class="row">
  <div class="col-lg-12 control-section">
    <ejs-querybuilder #querybuilder class="row" [rule]="importRules" [showButtons]="showButtons"
      (ruleChange)="onRuleChange($event)" width="80%" [columns]="columns">
    </ejs-querybuilder>
  </div>
</div>